<template>
  <div class="card">
    <div class="card-body mb-0 pb-0">
      <div class="row">
        <div class="col-lg-11" style="margin:0 auto">
          <export-evaluation v-if="applicationId" :application-id="applicationId"></export-evaluation>
        </div>
      </div>
    </div>
    <div class="card-body mt-0 pt-0" id="evaluationGrid">
      <div class="row">
        <div class="col-lg-11" style="margin:0 auto">
          <img style="padding-top: 2rem" class="mt-2" width="220" src="/img/logo.png">
          <div>
            <h4 class="card-title font-weight-bold mt-4">{{$t('reports.consolidated')}} -
              <span v-if="application">{{application.reference}}</span></h4>
          </div>
          <div>
            <table class="table-bordered border-left-0 border-right-0 table-full-width mt-3" cellpadding="20">
              <tr>
                <td>
                  <div class="d-flex">
                    <h4 class="card-title font-weight-bold mb-0 d-inline mr-5">{{$t('reports.due_diligence_risk')}}:
                      <span class="ml-2 font-weight-normal">{{diligenceRisk ? diligenceRisk.toUpperCase() : ''}}</span></h4>
                    <h4 class="card-title font-weight-bold mb-0 d-inline ml-5">{{$t('reports.esms_risk')}}:
                      <span class="ml-2 font-weight-normal">{{esmsRisk ? esmsRisk.toUpperCase() : ''}}</span></h4>
                  </div>
                </td>
                <td>
                  <h4 class="card-title font-weight-bold">
                    TOTAL: <span>{{totalScore}}</span>
                  </h4>
                </td>
              </tr>
            </table>
            <application-info v-if="application" :application="application"></application-info>
          </div>
          <div>
            <table class="table-bordered border-left-0 border-right-0 table-full-width mt-5" cellpadding="20">
              <tr>
                <th width="80%">{{$t('medium_grant_ev.technical__technical_criteria')}}</th>
                <th class="text-center" width="20%">{{$t('medium_grant_ev.technical__technical_final_score')}}</th>
              </tr>
              <tr>
                <td colspan="2" class="border-left-0 border-top-0 border-right-0 border-bottom-0"></td>
              </tr>
              <tr>
                <td colspan="2">
                  <h4 class="card-title font-weight-bold mb-0">{{$t('medium_grant_ev.technical__technical_1_title')}}</h4>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    {{$t('medium_grant_ev.technical__criteria_1_1')}}
                  </p>
                  <p>
                    {{$t('medium_grant_ev.technical__criteria_1_1_quantified')}}
                  </p>
                </td>
                <td class="text-center">
                  <p class="font-weight-bold">
                    {{$t('medium_grant_ev.technical__criteria_1_1_quantified_max')}}
                  </p>
                </td>
              </tr>
              <tr v-for="(evaluation, index) in evaluations" :key="'1_'+index">
                <td>
                  <h5 class="card-title font-weight-bold">Evaluator {{index+1}}</h5>
                  <p>
                    {{evaluation.model.comments_quantified}}
                  </p>
                </td>
                <td class="text-center">
                  {{evaluation.model.awarded_quantified}}
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    {{$t('medium_grant_ev.technical__criteria_1_1_strategic')}}
                  </p>
                  <p>
                    {{$t('medium_grant_ev.technical__criteria_1_1_studies')}}
                  </p>
                </td>
                <td class="text-center">
                  <p class="font-weight-bold">
                    {{$t('medium_grant_ev.technical__criteria_1_1_studies_max')}}
                  </p>
                </td>
              </tr>
              <tr v-for="(evaluation, index) in evaluations" :key="'2_'+index">
                <td>
                  <h5 class="card-title font-weight-bold">Evaluator {{index+1}}</h5>
                  <p>
                    {{evaluation.model.comments_strategic}}
                  </p>
                </td>
                <td class="text-center">
                  {{evaluation.model.awarded_strategic}}
                </td>
              </tr>
              <tr class="border-top-big">
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_1_2')}}
                  </p>
                </td>
                <td class="text-center">
                  <p class="font-weight-bold">
                    {{$t('medium_grant_ev.technical__criteria_1_2_max')}}
                  </p>
                </td>
              </tr>
              <tr v-for="(evaluation, index) in evaluations" :key="'3_'+index">
                <td>
                  <h5 class="card-title font-weight-bold">Evaluator {{index+1}}</h5>
                  <p>
                    {{evaluation.model.comments_critieria_one_two}}
                  </p>
                </td>
                <td class="text-center">
                  {{evaluation.model.criteria_one_two}}
                </td>
              </tr>
              <tr class="border-top-big">
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_1_3')}}
                  </p>
                </td>
                <td class="text-center">
                  <p class="font-weight-bold">
                    {{$t('medium_grant_ev.technical__criteria_1_3_max')}}
                  </p>
                </td>
              </tr>
              <tr v-for="(evaluation, index) in evaluations" :key="'4_'+index">
                <td>
                  <h5 class="card-title font-weight-bold">Evaluator {{index+1}}</h5>
                  <p>
                    {{evaluation.model.comments_critieria_one_three}}
                  </p>
                </td>
                <td class="text-center">
                  {{evaluation.model.criteria_one_three}}
                </td>
              </tr>
              <tr class="border-top-big">
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_1_4')}}
                  </p>
                </td>
                <td class="text-center">
                  <p class="font-weight-bold">
                    {{$t('medium_grant_ev.technical__criteria_1_4_max')}}
                  </p>
                </td>
              </tr>
              <tr v-for="(evaluation, index) in evaluations" :key="'5_'+index">
                <td>
                  <h5 class="card-title font-weight-bold">Evaluator {{index+1}}</h5>
                  <p>
                    {{evaluation.model.comments_critieria_one_four}}
                  </p>
                </td>
                <td class="text-center">
                  {{evaluation.model.criteria_one_four}}
                </td>
              </tr>
              <tr class="border-top-big">
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_1_5')}}
                  </p>
                </td>
                <td class="text-center">
                  <p class="font-weight-bold">
                    {{$t('medium_grant_ev.technical__criteria_1_5_max')}}
                  </p>
                </td>
              </tr>
              <tr v-for="(evaluation, index) in evaluations" :key="'6_'+index">
                <td>
                  <h5 class="card-title font-weight-bold">Evaluator {{index+1}}</h5>
                  <p>
                    {{evaluation.model.comments_critieria_one_five}}
                  </p>
                </td>
                <td class="text-center">
                  {{evaluation.model.criteria_one_five}}
                </td>
              </tr>
              <tr class="border-top-big">
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_1_6')}}
                  </p>
                </td>
                <td class="text-center">
                  <p class="font-weight-bold">
                    {{$t('medium_grant_ev.technical__criteria_1_6_max')}}
                  </p>
                </td>
              </tr>
              <tr v-for="(evaluation, index) in evaluations" :key="'7_'+index">
                <td>
                  <h5 class="card-title font-weight-bold">Evaluator {{index+1}}</h5>
                  <p>
                    {{evaluation.model.comments_critieria_one_six}}
                  </p>
                </td>
                <td class="text-center">
                  {{evaluation.model.criteria_one_six}}
                </td>
              </tr>
              <tr class="border-top-big">
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_1_7')}}
                  </p>
                </td>
                <td class="text-center">
                  <p class="font-weight-bold">
                    {{$t('medium_grant_ev.technical__criteria_1_7_max')}}
                  </p>
                </td>
              </tr>
              <tr v-for="(evaluation, index) in evaluations" :key="'8_'+index">
                <td>
                  <h5 class="card-title font-weight-bold">Evaluator {{index+1}}</h5>
                  <p>
                    {{evaluation.model.comments_critieria_one_seven}}
                  </p>
                </td>
                <td class="text-center">
                  {{evaluation.model.criteria_one_seven}}
                </td>
              </tr>
              <tr class="border-top-big">
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_1_8')}}
                  </p>
                </td>
                <td class="text-center">
                  <p class="font-weight-bold">
                    {{$t('medium_grant_ev.technical__criteria_1_8_max')}}
                  </p>
                </td>
              </tr>
              <tr v-for="(evaluation, index) in evaluations" :key="'9_'+index">
                <td>
                  <h5 class="card-title font-weight-bold">Evaluator {{index+1}}</h5>
                  <p>
                    {{evaluation.model.comments_critieria_one_eight}}
                  </p>
                </td>
                <td class="text-center">
                  {{evaluation.model.criteria_one_eight}}
                </td>
              </tr>
              <tr>
                <td colspan="2" class="border-left-0 border-top-0 border-right-0 border-bottom-0"></td>
              </tr>
              <tr>
                <td colspan="2">
                  <h4 class="card-title font-weight-bold mb-0">{{$t('medium_grant_ev.technical__criteria_2_sub')}}</h4>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_2')}}
                  </p>
                </td>
              </tr>
              <tr class="border-top-big">
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_2_1')}}
                  </p>
                </td>
                <td class="text-center">
                  <p class="font-weight-bold">
                    {{$t('medium_grant_ev.technical__criteria_2_1_max')}}
                  </p>
                </td>
              </tr>
              <tr v-for="(evaluation, index) in evaluations" :key="'10_'+index">
                <td>
                  <h5 class="card-title font-weight-bold">Evaluator {{index+1}}</h5>
                  <p>
                    {{evaluation.model.comments_critieria_two_one}}
                  </p>
                </td>
                <td class="text-center">
                  {{evaluation.model.criteria_two_one}}
                </td>
              </tr>
              <tr class="border-top-big">
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_2_2')}}
                  </p>
                </td>
                <td class="text-center">
                  <p class="font-weight-bold">
                    {{$t('medium_grant_ev.technical__criteria_2_2_max')}}
                  </p>
                </td>
              </tr>
              <tr v-for="(evaluation, index) in evaluations" :key="'11_'+index">
                <td>
                  <h5 class="card-title font-weight-bold">Evaluator {{index+1}}</h5>
                  <p>
                    {{evaluation.model.comments_critieria_two_two}}
                  </p>
                </td>
                <td class="text-center">
                  {{evaluation.model.criteria_two_two}}
                </td>
              </tr>
              <tr class="border-top-big">
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_2_3')}}
                  </p>
                </td>
                <td class="text-center">
                  <p class="font-weight-bold">
                    {{$t('medium_grant_ev.technical__criteria_2_3_max')}}
                  </p>
                </td>
              </tr>
              <tr v-for="(evaluation, index) in evaluations" :key="'12_'+index">
                <td>
                  <h5 class="card-title font-weight-bold">Evaluator {{index+1}}</h5>
                  <p>
                    {{evaluation.model.comments_critieria_two_three}}
                  </p>
                </td>
                <td class="text-center">
                  {{evaluation.model.criteria_two_three}}
                </td>
              </tr>
              <tr>
                <td colspan="2" class="border-left-0 border-top-0 border-right-0 border-bottom-0"></td>
              </tr>
              <tr>
                <td colspan="2">
                  <h4 class="card-title font-weight-bold mb-0">{{$t('medium_grant_ev.technical__criteria_3')}}</h4>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_3_sub')}}
                  </p>
                </td>
              </tr>
              <tr class="border-top-big">
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_3_1')}}
                  </p>
                </td>
                <td class="text-center">
                  <p class="font-weight-bold">
                    {{$t('medium_grant_ev.technical__criteria_3_1_max')}}
                  </p>
                </td>
              </tr>
              <tr v-for="(evaluation, index) in evaluations" :key="'13_'+index">
                <td>
                  <h5 class="card-title font-weight-bold">Evaluator {{index+1}}</h5>
                  <p>
                    {{evaluation.model.comments_critieria_three_one}}
                  </p>
                </td>
                <td class="text-center">
                  {{evaluation.model.criteria_three_one}}
                </td>
              </tr>
              <tr class="border-top-big">
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_3_2')}}
                  </p>
                </td>
                <td class="text-center">
                  <p class="font-weight-bold">
                    {{$t('medium_grant_ev.technical__criteria_3_2_max')}}
                  </p>
                </td>
              </tr>
              <tr v-for="(evaluation, index) in evaluations" :key="'14_'+index">
                <td>
                  <h5 class="card-title font-weight-bold">Evaluator {{index+1}}</h5>
                  <p>
                    {{evaluation.model.comments_critieria_three_two}}
                  </p>
                </td>
                <td class="text-center">
                  {{evaluation.model.criteria_three_two}}
                </td>
              </tr>
              <tr>
                <td colspan="2" class="border-left-0 border-top-0 border-right-0 border-bottom-0"></td>
              </tr>
              <tr>
                <td colspan="2">
                  <h4 class="card-title font-weight-bold mb-0">{{$t('medium_grant_ev.technical__criteria_4')}}</h4>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_4_sub')}}
                  </p>
                </td>
              </tr>
              <tr class="border-top-big">
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_4_1')}}
                  </p>
                </td>
                <td class="text-center">
                  <p class="font-weight-bold">
                    {{$t('medium_grant_ev.technical__criteria_4_1_max')}}
                  </p>
                </td>
              </tr>
              <tr v-for="(evaluation, index) in evaluations" :key="'15_'+index">
                <td>
                  <h5 class="card-title font-weight-bold">Evaluator {{index+1}}</h5>
                  <p>
                    {{evaluation.model.comments_critieria_four_one}}
                  </p>
                </td>
                <td class="text-center">
                  {{evaluation.model.criteria_four_one}}
                </td>
              </tr>
              <tr>
                <td colspan="2" class="border-left-0 border-top-0 border-right-0 border-bottom-0"></td>
              </tr>
              <tr>
                <td colspan="2">
                  <h4 class="card-title font-weight-bold mb-0">{{$t('medium_grant_ev.technical__criteria_5')}}</h4>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_5_sub')}}
                  </p>
                </td>
              </tr>
              <tr class="border-top-big">
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_5_1')}}
                  </p>
                </td>
                <td class="text-center">
                  <p class="font-weight-bold">
                    {{$t('medium_grant_ev.technical__criteria_5_1_max')}}
                  </p>
                </td>
              </tr>
              <tr v-for="(evaluation, index) in evaluations" :key="'16_'+index">
                <td>
                  <h5 class="card-title font-weight-bold">Evaluator {{index+1}}</h5>
                  <p>
                    {{evaluation.model.comments_critieria_five_one}}
                  </p>
                </td>
                <td class="text-center">
                  {{evaluation.model.criteria_five_one}}
                </td>
              </tr>

              <tr>
                <td colspan="2" class="border-left-0 border-top-0 border-right-0 border-bottom-0"></td>
              </tr>
              <tr>
                <td colspan="2">
                  <h4 class="card-title font-weight-bold mb-0">FINAL ADDITIONAL COMMENTS</h4>
                </td>
              </tr>
              <tr class="border-top-big" v-for="(final_comment, index) in final_comments" :key="'comment_'+index">
                <td colspan="2">
                  <comment-box :hide-author="true" :is-editable="false" v-model="final_comment.model.comments" :comments="final_comment.model.comments"></comment-box>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {ReportsService} from "@/services";
  import {ExportEvaluation} from 'src/components';
  import ApplicationInfo from "./ApplicationInfo";
  import {Select, Option} from 'element-ui';
  import {CommentBox} from 'src/components';

  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      ExportEvaluation,
      CommentBox,
      ApplicationInfo
    },
    data() {
      return {
        application: {},
        evaluations: [],
        final_comments: [],
        diligence_evaluation: null,
        esms_evaluation: null,
        applicationId: parseInt(this.$route.params.applicationId)
      }
    },
    computed: {
      diligenceRisk() {
        let vm = this;
        if (!vm.diligence_evaluation) {
          return '-';
        }

        let total_score = vm.diligence_evaluation.total_score;
        if (total_score <= 25) {
          return this.$t('medium_grant_ev.diligence__info_risk_low');
        } else if (total_score > 25 && total_score <= 40) {
          return this.$t('medium_grant_ev.diligence__info_risk_medium');
        } else if (total_score > 40) {
          return this.$t('medium_grant_ev.diligence__info_risk_high');
        }
      },
      esmsRisk() {
        let vm = this;
        if (!vm.esms_evaluation) {
          return '-';
        }

        let evmodel = vm.esms_evaluation.model.info_risk_assessment;
        if (evmodel === 'verified') {
          return this.$t('medium_grant_ev.esms__info_low');
        } else if (evmodel === 'unverifiable') {
          return this.$t('medium_grant_ev.esms__info_medium');
        } else if (evmodel === 'clarification') {
          return this.$t('medium_grant_ev.esms__info_high');
        }
      },
      totalScore() {
        let vm = this;

        let total = 0;
        vm.evaluations.forEach(function(item) {
          total += item.total_score;
        })

        if(vm.evaluations.length) {
          total = (total / vm.evaluations.length);
        }

        if(total === 0) {
          return '-';
        } else {
          return total.toFixed(0);
        }
      }
    },
    methods: {
      async getEvaluation() {
        let vm = this;
        let loader = vm.$loading.show();

        await ReportsService.getEvaluation(vm.applicationId).then(function (response) {
          let result = response.data;

          vm.application = result.application;
          vm.evaluations = result.technical;
          vm.final_comments = result.final_comments;

          vm.application.evaluations.forEach(function (evaluation) {
            if (evaluation.type.nickname === 'diligence') {
              vm.diligence_evaluation = evaluation;
            } else if (evaluation.type.nickname === 'esms') {
              vm.esms_evaluation = evaluation;
            }
          })
        })

        loader.hide();
      }
    },
    mounted() {
      let vm = this;
      vm.getEvaluation();
    }
  }
</script>
<style scoped>
  textarea {
    resize: vertical !important;
  }

  .border-top-big {
    border-top: 2px solid black;
  }
</style>